import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=0bc4161b&"
import script from "./Checkout.js?vue&type=script&lang=js&"
export * from "./Checkout.js?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=0bc4161b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports